type EditUnavailabilityError = {
  emptyName: boolean;
  invalidDateRange: boolean;
  invalidStartDate: boolean;
  invalidUnavailabilityDates: boolean;
  invalidUnavailabilityNonWorkedHoursCount: boolean;
  invalidResource: boolean;
  invalidReason: boolean;
};

const editUnavailabilityError: EditUnavailabilityError = {
  emptyName: false,
  invalidDateRange: false,
  invalidStartDate: false,
  invalidUnavailabilityDates: false,
  invalidUnavailabilityNonWorkedHoursCount: false,
  invalidResource: false,
  invalidReason: false,
};

export type { EditUnavailabilityError };

export { editUnavailabilityError };
